/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppPlaybookRouteImport } from './routes/_app/playbook'
import { Route as AppPlaybookIndexRouteImport } from './routes/_app/playbook/index'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppPlaybookIntentIdRouteImport } from './routes/_app/playbook/$intentId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPlaybookRoute = AppPlaybookRouteImport.update({
  id: '/playbook',
  path: '/playbook',
  getParentRoute: () => AppRoute,
} as any)
const AppPlaybookIndexRoute = AppPlaybookIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPlaybookRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppPlaybookIntentIdRoute = AppPlaybookIntentIdRouteImport.update({
  id: '/$intentId',
  path: '/$intentId',
  getParentRoute: () => AppPlaybookRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/playbook': typeof AppPlaybookRouteWithChildren
  '/playbook/$intentId': typeof AppPlaybookIntentIdRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/playbook/': typeof AppPlaybookIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/playbook/$intentId': typeof AppPlaybookIntentIdRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/playbook': typeof AppPlaybookIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_app/playbook': typeof AppPlaybookRouteWithChildren
  '/_app/playbook/$intentId': typeof AppPlaybookIntentIdRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/playbook/': typeof AppPlaybookIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/login'
    | '/playbook'
    | '/playbook/$intentId'
    | '/settings/users'
    | '/playbook/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/playbook/$intentId'
    | '/settings/users'
    | '/playbook'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/callback'
    | '/login'
    | '/_app/playbook'
    | '/_app/playbook/$intentId'
    | '/_app/settings/users'
    | '/_app/playbook/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/playbook': {
      id: '/_app/playbook'
      path: '/playbook'
      fullPath: '/playbook'
      preLoaderRoute: typeof AppPlaybookRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/playbook/': {
      id: '/_app/playbook/'
      path: '/'
      fullPath: '/playbook/'
      preLoaderRoute: typeof AppPlaybookIndexRouteImport
      parentRoute: typeof AppPlaybookRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/playbook/$intentId': {
      id: '/_app/playbook/$intentId'
      path: '/$intentId'
      fullPath: '/playbook/$intentId'
      preLoaderRoute: typeof AppPlaybookIntentIdRouteImport
      parentRoute: typeof AppPlaybookRoute
    }
  }
}

interface AppPlaybookRouteChildren {
  AppPlaybookIntentIdRoute: typeof AppPlaybookIntentIdRoute
  AppPlaybookIndexRoute: typeof AppPlaybookIndexRoute
}

const AppPlaybookRouteChildren: AppPlaybookRouteChildren = {
  AppPlaybookIntentIdRoute: AppPlaybookIntentIdRoute,
  AppPlaybookIndexRoute: AppPlaybookIndexRoute,
}

const AppPlaybookRouteWithChildren = AppPlaybookRoute._addFileChildren(
  AppPlaybookRouteChildren,
)

interface AppRouteChildren {
  AppPlaybookRoute: typeof AppPlaybookRouteWithChildren
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPlaybookRoute: AppPlaybookRouteWithChildren,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
